import { CAMPAIGN_NAME_MAX_LENGTH } from "@/constants/campaignBuilder";
import type { CampaignNameModalMode } from "@/interfaces/CampaignBuilder";

/**
 * Returns `value` with leading/trailing whitespace removed (String.prototype.trim semantics).
 * Inner whitespace is untouched.
 */
export function normalizeCampaignName(value: string): string {
  return value.trim();
}

/**
 * True iff the trimmed value is non-empty AND its length is <= CAMPAIGN_NAME_MAX_LENGTH.
 */
export function isValidCampaignName(value: string): boolean {
  const name = normalizeCampaignName(value);
  return name.length > 0 && name.length <= CAMPAIGN_NAME_MAX_LENGTH;
}

/**
 * Which modal to show: `"create"` when `isNewCampaign` and the trimmed `campaignName` is empty
 * (create wins over rename); otherwise `"rename"` when `isRenaming`; otherwise `null`.
 */
export function campaignNameModalMode(state: {
  isNewCampaign: boolean;
  campaignName: string;
  isRenaming: boolean;
}): CampaignNameModalMode | null {
  if (state.isNewCampaign && normalizeCampaignName(state.campaignName) === "") return "create";
  return state.isRenaming ? "rename" : null;
}
